import { render, staticRenderFns } from "./create-popup-quiz.html?vue&type=template&id=7fbc63ea&scoped=true&"
import script from "./create-popup-quiz.vue?vue&type=script&lang=js&"
export * from "./create-popup-quiz.vue?vue&type=script&lang=js&"
import style0 from "./create-popup-quiz.css?vue&type=style&index=0&id=7fbc63ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc63ea",
  null
  
)

export default component.exports